@if (!isLoading && !hasError) {
    <span class="js-label" [innerHtml]="count"></span>
}
@if (isLoading || hasError) {
    <wdx-spinner
        [small]="true"
        [themeColor]="hasError ? 'danger' : 'primary'"
    ></wdx-spinner>
}
